import { render, staticRenderFns } from "./StepUpdateNames.vue?vue&type=template&id=3b00b032&scoped=true&"
import script from "./StepUpdateNames.vue?vue&type=script&lang=js&"
export * from "./StepUpdateNames.vue?vue&type=script&lang=js&"
import style0 from "./StepUpdateNames.vue?vue&type=style&index=0&id=3b00b032&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b00b032",
  null
  
)

export default component.exports